import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Staff } from '@app/models/staff.model';
import { User } from '@app/models/user.model';
import { UserService } from '@app/services/dai.service';
import { DialogService } from '@app/services/dialog.service';
import { StaffService } from '@app/services/staff.service';

@Component({
  selector: 'app-search-select',
  templateUrl: './search-select.component.html',
  styleUrls: ['./search-select.component.scss'],
})
export abstract class SearchSelectComponent implements OnInit {
  @Input() arrowType: number = 0;
  @Input() multiple?: boolean = false;
  @Input() clear?: boolean;
  @Input() placeholder: string = '選択して下さい';
  @Input() allowNull?: boolean = true;
  @Input() fieldLabel?: string;
  @Output() userChange = new EventEmitter<User>();
  @Output() staffChange = new EventEmitter<Staff | null>();
  @Output() usersChange = new EventEmitter<string[]>();
  @Output() staffsChange = new EventEmitter<string[]>();

  control: FormControl;
  private _selectedId: string[] = [];

  get userList() {
    return this.userService.userList;
  }

  get staffList() {
    return this.staffService.staffList;
  }

  @Input()
  get selectedId(): string[] {
    return this._selectedId;
  }

  set selectedId(value: string[] | string) {
    if (Array.isArray(value)) {
      this._selectedId = value;
    } else if (typeof value === 'string') {
      this._selectedId = [value];
    } else {
      this._selectedId = [];
    }
  }
  private _form!: FormControl;
  @Input()
  get form(): FormControl {
    return this._form;
  }
  set form(form: FormControl) {
    if (!form) return;
    this._form = form;

    if (this.userList) {
      const user = this.userList.find((item) => item.daicd === form.value);
      this.control.setValue(user?.name);
    } else if (this.staffList) {
      const staff = this.staffList.find((item) => item.stfcd === form.value);
      this.control.setValue(staff?.name);
    }

    if (form.disabled) {
      this.control.disable();
    }
  }

  constructor(
    protected userService: UserService,
    protected staffService: StaffService,
    protected dialog: DialogService
    ) {
    this.control = new FormControl();
  }
  // ngOnChanges(changes: SimpleChanges): void {
  //   if (changes['selectedId']) {
  //     if (this.selectedId.length > 0) {
  //       if (this.staffList) {
  //         let staffList = this.staffList.filter(stf => this.selectedId.some(stfcd => stfcd === stf.stfcd)).map(x => x.name);
  //         if (this.selectedId.some(x => x === '-1')) {
  //           staffList.push(`（担当者未割り当て）`);
  //         }
  //         this.setListControlValue(staffList);
  //       }
  //       if (this.userList) {
  //         this.setListControlValue(this.userList.filter(dai => this.selectedId.some(daicd => daicd === dai.daicd)).map(x => x.name));
  //       }
  //     } else {
  //       this.control.setValue([]);
  //     }
  //   }
  // }


  setListControlValue(list: string[], suffix: string = '件選択') {
    const dedupeList = Array.from(new Set(list));
    if (dedupeList.length === 0) {
      this.control.setValue('');
      return;
    }
    if (dedupeList.length === 1) {
      this.control.setValue(dedupeList[0]);
    }
    if (dedupeList.length > 1) {
      this.control.setValue(`${dedupeList.length} ${suffix}`);
    }

  }

  ngOnInit(): void {
    this.form?.valueChanges.subscribe((value) => {
      if (this.userList) {
        const user = this.userList.find((item) => item.daicd === value);
        this.control.setValue(user?.name);
      } else if (this.staffList) {
        const staff = this.staffList.find((item) => item.stfcd === value);
        this.control.setValue(staff?.name);
      }
    });
  }
  onClick() { }
  // abstract onClick(): void;
  // abstract onClick(): void {
  //   // if (this.control.disabled) return;

  //   // const data = {
  //   //   userList: this.userList,
  //   //   staffList: this.staffList,
  //   //   teamList: this.teamList,
  //   //   clear: this.clear,
  //   //   multiple: this.multiple,
  //   //   selectedId: this.selectedId,
  //   //   allowNull: this.allowNull
  //   // };

  //   // const dialogRef = this.dialog.select(data);
  //   // dialogRef
  //   //   .afterClosed()
  //   //   .pipe(filter((result) => !!result))
  //   //   .subscribe((result) => {
  //   //     if (result.clear) {
  //   //       this.control.setValue(null);
  //   //       this.form.setValue(null);
  //   //       this.staffChange.emit(null);
  //   //     } else if (this.staffList) {
  //   //       if (Array.isArray(result)) {
  //   //         let staffList = this.staffList.filter(stf => result.some(stfcd => stfcd === stf.stfcd)).map(x => x.name);
  //   //         if (result.some(x => x === '-1')) {
  //   //           staffList.push(`（担当者未割り当て）`);
  //   //         }
  //   //         this.setListControlValue(staffList);
  //   //         this.staffsChange.emit(result);
  //   //         return;
  //   //       } else {
  //   //         this.control.setValue(result.name);
  //   //         this.form.setValue(result.stfcd);
  //   //         this.staffChange.emit(result);
  //   //       }

  //   //     } else if (this.userList) {
  //   //       if (Array.isArray(result)) {
  //   //         this.setListControlValue(this.userList.filter(dai => result.some(daicd => daicd === dai.daicd)).map(x => x.name));
  //   //         this.usersChange.emit(result);
  //   //         return;
  //   //       } else {
  //   //         this.control.setValue(result.name);
  //   //         this.form.setValue(result.daicd);
  //   //         this.userChange.emit(result);
  //   //       }

  //   //     }
  //   //   });
  // }
}
